import сertificate1 from '../img/сertificates/UAEP_ISO_UKR.png';

export const sliderAbout = [сertificate1];
